/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import {
    IMoeV2ResourcePageDownloadViewProps,
    IFileArtifact,
    getFileIcon,
    DownloadIcon,
    formatFileSize
} from './moe-v2-resource-page-download';

export default (props: IMoeV2ResourcePageDownloadViewProps) => {
    const { config, artifacts } = props;

    const handleDownload = (fileUrl: string, fileName: string) => {
        // Create a temporary anchor element to trigger download
        const link = document.createElement('a');
        link.href = `${fileUrl}`;
        link.download = fileName;
        link.style.display = 'none';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className='moe-v2-module-container-file-download moe-v2-resource-page-download'>
            <h2 className='moe-v2-resource-page-download__title'>{config.title}</h2>
            <div className='moe-v2-resource-page-download__container'>
                <div className='moe-v2-resource-page-download__list'>
                    {artifacts &&
                        artifacts.length > 0 &&
                        artifacts.map((artifact: IFileArtifact, index) => {
                            const itemId = `file-${index}`;
                            const fileType = artifact.FileType?.toUpperCase() || 'UNKNOWN';
                            const fileName = artifact.MediaName || `File ${index + 1}`;
                            const fileUrl = artifact.MediaUrl || '';
                            const fileSize = formatFileSize(artifact.FileSize || '0B');

                            return (
                                <div key={itemId} className='moe-v2-resource-page-download__item'>
                                    <div className='moe-v2-resource-page-download__item-main'>
                                        <div className='moe-v2-resource-page-download__icon'>{getFileIcon(fileType)}</div>

                                        <div className='moe-v2-resource-page-download__content'>
                                            <span className='moe-v2-resource-page-download__filename'>{fileName}</span>
                                        </div>

                                        <div className='moe-v2-resource-page-download__actions'>
                                            <button
                                                className='moe-v2-resource-page-download__download-btn'
                                                onClick={() => handleDownload(fileUrl ?? '', fileName)}
                                                aria-label={`Download ${fileName}`}
                                            >
                                                <span className='moe-v2-resource-page-download__download-text'>Download</span>
                                                {DownloadIcon}
                                            </button>

                                            <span className='moe-v2-resource-page-download__file-info'>
                                                {fileType.toUpperCase()} | {fileSize}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    {(!artifacts || artifacts.length === 0) && (
                        <div className='moe-v2-resource-page-download__empty'>
                            <p>No files available for download.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
